/**
 * This is the OS-level default we should fall back to if/when the user
 * hasn't chosen a theme in our app.
 */
export const prefersDarkMode = (): boolean =>
  window.matchMedia('(prefers-color-scheme: dark)').matches

/** Applies the theme to the document. Called at startup and on every `darkMode` change in redux. */
export const applyDarkModeToDocument = (darkMode: boolean): void => {
  document
    .getElementsByTagName('html')[0]
    .setAttribute('class', darkMode ? 'dark' : 'light')
}
